<div class="d-flex align-items-start flex-column" >
    <span class="indicator-tags_tags" *ngFor="let tag  of params" [style.backgroundColor]="tag?.colorCode" [matTooltip]= "tag.name" >{{ tag.name }}</span>
</div>